import useSWRImmutable from "swr/immutable"

import { LCTOnlyDatasets } from "../../../constants/enums"
import { getClientPublic } from "../clients/clients"
import {
    TDemandRefOutput,
    demandFilterReferenceMapper,
} from "../mappers/demandFilterReferenceMapper"
import { DEMAND_REFERENCE } from "../urls/hybrid"

type TUseDemandFilterReference = {
    referenceData: TDemandRefOutput | undefined
    isLoading: boolean
    isError: boolean
}

/**
 * Hook for getting demand search filter panel reference data. Reference data
 * is immutable (it is highly unlikely to change over the course of a session)
 * and therefore the `useSWRImmutable` hook is used.
 * @returns {TUseDemandFilterReference} - SWR data, loading and error states.
 */
const useDemandFilterReferenceData = (
    dataset: LCTOnlyDatasets
): TUseDemandFilterReference => {
    const {
        data: referenceData,
        error,
        isLoading,
    } = useSWRImmutable(
        DEMAND_REFERENCE(dataset),
        async (url: string): Promise<TDemandRefOutput> => {
            try {
                const res = await getClientPublic(url)
                return demandFilterReferenceMapper.map(res)
            } catch {
                throw Error()
            }
        }
    )

    return {
        referenceData,
        isLoading,
        isError: error,
    }
}

export default useDemandFilterReferenceData
